import { render, staticRenderFns } from "./SectionsView.vue?vue&type=template&id=ebefb8aa"
import script from "./SectionsView.vue?vue&type=script&lang=js"
export * from "./SectionsView.vue?vue&type=script&lang=js"
import style0 from "./SectionsView.vue?vue&type=style&index=0&id=ebefb8aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports